// stores/main-store.js

import { defineStore } from 'pinia'

export const useMainStore = defineStore('main', {
  state: () => ({
    isHeaderTransparent: false,
    currentStep: null,
    fetchLocales: false,
    langSelected: '',
    languages: [],
    fetchCountries: false,
    countrySelected: '',
    countries: [],
    countryZoneSelected: '',
    countryZoneCitySelected: '',
    currencies: [],
    currencySelected: '',
  }),
  actions: {
    setTransparent(value) {
      this.isHeaderTransparent = value
    },

    setLanguages(languages) {
      '', (this.languages = languages)
    },

    setCountries(countries) {
      useState('countries', countries)
      this.countries = countries
    },

    setCurrencies(currencies) {
      useState('currencies', currencies)
      this.currencies = currencies
    },

    setLangSelected(lang) {
      useState('lang-selected', lang)
      this.langSelected = lang
    },

    setCurrencySelected(currency) {
      sessionStorage.setItem('currencySelected', currency)
      this.currencySelected = currency
    },

    setCountrySelected(country) {
      useState('countrySelected', country)
      this.countrySelected = country
    },

    setCountryZoneSelected(zoneId) {
      this.countryZoneSelected = zoneId
    },

    setCountryZoneCitySelected(cityId) {
      this.countryZoneCitySelected = cityId
    },

    resetLang() {
      this.langSelected = null
    },

    resetCountry() {
      this.countrySelected = null
    },

    getLanguageSelected() {
      return (
        this.languages.find(
          (language) => language.slug === this.langSelected
        ) || {}
      )
    },

    getCountrySelected() {
      return (
        this.countries.find(
          (country) => country.code === this.countrySelected
        ) || {}
      )
    },

    getZoneSelected() {
      return (
        this.getCountrySelected()?.zones.find(
          (zone) => zone.id === this.countryZoneSelected
        ) || {}
      )
    },

    getCitySelected() {
      return (
        this.getZoneSelected()?.cities.find(
          (city) => city.id === this.countryZoneCitySelected
        ) || {}
      )
    },

    resetCountryFilter() {
      this.countryZoneSelected = ''
      this.countryZoneCitySelected = ''
    },
  },
})
